import { embedCard as embedCardFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils/uuid';

/**
 * @name embedCard_node
 */

export const embedCard = embedCardFactory({
  parseDOM: [{
    tag: 'div[data-embed-card]',
    getAttrs: dom => ({
      url: dom.getAttribute('data-card-url'),
      layout: dom.getAttribute('data-layout') || 'center',
      width: Number(dom.getAttribute('data-width')) || null,
      originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
      originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
    })
  }],
  toDOM(node) {
    const {
      url,
      layout,
      width,
      originalWidth,
      originalHeight
    } = node.attrs;
    const attrs = {
      'data-embed-card': '',
      'data-card-url': url,
      'data-layout': layout,
      'data-width': width,
      'data-original-width': originalWidth,
      'data-original-height': originalHeight
    };
    return ['div', attrs];
  }
});
export const embedCardWithLocalId = embedCardFactory({
  parseDOM: [{
    tag: 'div[data-embed-card]',
    getAttrs: dom => ({
      url: dom.getAttribute('data-card-url'),
      layout: dom.getAttribute('data-layout') || 'center',
      width: Number(dom.getAttribute('data-width')) || null,
      originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
      originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
      localId: uuid.generate()
    })
  }],
  toDOM(node) {
    var _node$attrs;
    const {
      url,
      layout,
      width,
      originalWidth,
      originalHeight
    } = node.attrs;
    const attrs = {
      'data-embed-card': '',
      'data-card-url': url,
      'data-layout': layout,
      'data-width': width,
      'data-original-width': originalWidth,
      'data-original-height': originalHeight,
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
    };
    return ['div', attrs];
  }
});